import service from '@/request/global'

// 首页更多资讯的接口
export function gethomelist(id1,id2,page) {
  return service.get(`https://common.gcpdata.cn/api/dataNews/getByCataId?newsCata=${id1}&newsSysId=${id2}&pageSize=${page}`, {
    headers: {
      'content-type': 'application/json'
    }
  })
}
//医院审核
export function getData(data) {
  return service.post(`/admin/findNotOrgList2`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//医院审核统计
export function getData1(data) {
  return service.get(`/admin/orgDataCount/2`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//医院已审核
export function getData2(data) {
  return service.post(`/admin/findYesOrgList2`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//医院状态
export function statua(data) {
  return service.post(`/admin/checkState`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//公司审核
export function getDatacompany(data) {
  return service.post(`/admin/findNotOrgList1`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//公司审核统计
export function getDatacompany1(data) {
  return service.get(`/admin/orgDataCount/1`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//公司已审核
export function getDatacompany2(data) {
  return service.post(`/admin/findYesOrgList1`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//公司状态
export function companystatua(data) {
  return service.post(`/admin/checkState`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//CRC列表
export function crcgetData(data) {
  return service.post(`/admin/findCrcList`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
//CRC统计
export function crcgetDatatongji(data) {
  return service.get(`/admin/crcDataCount`, data, {
	   headers: {
      'content-type': 'application/json'
    }
  })
}
// 首页更多资讯详情的接口
export function gethomeMsg(id) {
  return service.get(`https://common.gcpdata.cn/api/dataNews/getById/${id}`, {
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 手机号登陆
export function loginInOut(data) {
  return service.post('/open/mobile-login', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 短信验证码登陆
export function loginInOut2(data) {
  return service.post('/open/code-login', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

//微信登录

export function loginInOut3(data) {
  return service.post('/open/wxopen/login', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}


//微信绑定手机号



export function wxbindMobile(data) {
  return service.post('/open/wxopen/bindMobile', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 医院端****************************************************************************************
// 请求专业下拉菜单
export function getSpecialty(id) {
  return service.get(`https://common.gcpdata.cn/api/dataSpecialty/getListByPid/${id}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 医院首页添加项目
export function addproject(data) {
  return service.post('/crc/projects/add', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 医院首页修改项目
export function editproject(data) {
  return service.post('/crc/projects/update', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}
// 获取公司名称搜索
export function companyNmae(companyName) {
  return service.get(`/crc/companies/search/${companyName}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}


// 医院首页列表
export function projectlist(data) {
  return service.post(`/crc/projects/hospital-projects-page`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}


// crc接收人员列表
export function projectpersonlist(projectId) {
  return service.get(`/crc/project-experiences/delegate-detail/${projectId}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}


// 
export function crcReceive(data) {
  return service.post(`/crc/project-experiences/delegate-receive-multiple`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

//人员管理
export function crcManager(data) {
  return service.post(`/crc/hospital/crc-manager`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 简历详情
export function preview(id) {
  return service.get(`/crc/users/personal-record-info/${id}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// crc人员接收
export function crcBatch(data) {
  return service.post(`/crc/hospital/batch-receive`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

//crc评价列表
export function evaluate(projectId) {
  return service.get(`/crc/hospital/evaluate-page-info/${projectId}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}


//crc评价

export function pj(data) {
  return service.post(`/crc/project-experiences/project-confirm`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

//医院数据统计
export function statistics(userId) {
  return service.get(`/crc/hospital/statistics/${userId}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 医院信息
export function hospitalMsg(userId) {
  return service.post(`/crc/hospital/org-info/${userId}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 修改联系人信息
export function modifyContact(data) {
  return service.post(`/crc/hospital/modify-contact`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

//修改密码
export function hospitalPwd(data) {
  return service.post(`/crc/users/update-pwd`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 权限管理

export function hospitaManagement(data) {
  return service.post(`/crc/hospital/account-info`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 医院新增管理人员

export function addManagement(data) {
  return service.post(`/crc/users/add-sub-account`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}


//医院编辑管理人员回显
export function editManagementmsg(data) {
  return service.post(`/crc/users/updateById `, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

//获取短信验证码
// 1.注册   2.忘记密码/验证码登录 3.修改手机号
export function getSmsCode(data) {
  return service.post(`/open/sms/send2`,data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
export function getSmsCode2(mobile) {
  return service.post(`/open/sms/send/${mobile}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
//图形验证码
  
  export function getImgcode() {
    return service.get(`/open/imgcode`, {
      headers: {
        'content-type': 'application/json'
      }
    })
  }
// 用户端**************************************************************************************************
//个人修改头像
export function editWorkimg(data) {
  return service.post(`/crc/users/modify-workimg`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 个人用户消息获取
export function getpersoninfo(userId) {
  return service.get(`/crc/users/personal-record-info/${userId}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
//学历下拉菜单
export function getEdu() {
  return service.get(`https://common.gcpdata.cn/api/dataDictionary/getListBySysIdAndType/0/1`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

//添加教育经历
export function addEdu(data) {
  return service.post(`/crc/education-exp/add`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

//修改教育经历
export function editEdu(data) {
  return service.post(`crc/education-exp/update`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
//添加培训经历
export function addTrain(data) {
  return service.post(`/crc/train-exp/add`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
// 编辑培训经历
export function editTrain(data) {
  return service.post(`/crc/train-exp/update`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
// 添加获得证书
export function getcertificate(data) {
  return service.post(`/crc/certificates/add`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
//编辑证书
export function editcertificate(data) {
  return service.post(`/crc/certificates/update`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 新增个人项目经历
export function projectExperiences(data) {
  return service.post(`/crc/project-experiences/personal-add`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

//修改个人项目经历
export function editExperiences(data) {
  return service.post(`/crc/project-experiences/update`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 医院注册验证是否注册过
export function orgExist(orgName) {
  return service.post(`/open/org-exist/${orgName}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 医院注册手机号
export function sedcode(mobile) {
  return service.post(`/open/sms/send/${mobile}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}


//注册
export function hospitalRes(data) {
  return service.post(`/open/pc-hospital-reg`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 公司端*********************************************************************************************

// 首页列表和搜索
export function Cprojectslist(data) {
  return service.post(`/crc/companies/company-projects`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 委派页面列表

export function Cappointlist(data) {
  return service.post(`/crc/companies/crc-info-list`,data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 委派
export function Cappoint(data) {
  return service.post(`/crc/project-experiences/add-delegate`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 详情
export function receivingDetails(projectId) {
  return service.get(`/crc/project-experiences/delegate-detail/${projectId}`, 
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
// 详情
export function receivingDetails2(projectId) {
  return service.get(`/crc/project-experiences/delegate-detail2/${projectId}`, 
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 详情
export function appointLetter(data) {
  return service.post(`/crc/project-experiences/appointLetter`,data, 
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
 
//公司数据统计
export function Cstatistics(userId) {
  return service.get(`/crc/companies/statistics/${userId}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 公司人员管理
export function Cperson(data) {
  return service.post(`/crc/companies/crc-manager`, data,
  {
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 公司信息详情
export function companyMsg(userId) {
  return service.post(`/crc/companies/org-info/${userId}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 公司联系人修改
export function CompanyContact(data) {
  return service.post(`/crc/companies/modify-contact`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 公司权限

export function companyManagement(userid) {
  return service.post(`/crc/companies/account-info/${userid}`,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 修改手机号
export function telEait(data) {
  return service.post(`/crc/ucenter/personal/change-mobile`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}

// 公司注册第一步
export function companyreg1(data) {
  return service.post(`/open/pc-companyreg1`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
// 公司注册第2步
export function companyreg2(data) {
  return service.post(`/open/pc-companyreg2`, data,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
}
//公司新增人员
export function addperson(mobile,code) {
  return service.get(`/crc/users/record-info/${mobile}/${code}`,
  {
    headers: {
      'content-type': 'application/json'
    }
  })
}

export function addsbtn(userId,crcId) {
  return service.get(`/crc/companies/binding-crc/${userId}/${crcId}`,
  {
    headers: {
      'content-type': 'application/json'
    }
  })
}
// POST /api/crc/companies/subAccountInfo
export function subAccountInfo(data) {
  return service.post(`/crc/companies/subAccountInfo`,data,
  {
    headers: {
      'content-type': 'application/json'
    }
  })
}

//公司人员修改
export function updata1(data) {
  return service.post(`/crc/users/update`,data,
  {
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 公司权限管理医院列表sousu
export function gethospitallist() {
  return service.get(`/crc/hospital/findAllOrgList`, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

// 公司权限管理医院列表sousu
export function gethospitallist2(name) {
  return service.get(`/crc/hospital/search/${name}`, {
    headers: {
      'content-type': 'application/json'
    }
  })
}


// 医院的账号请求是否是isadmin   /api/crc/usersfindById?id=123
export function usersfindById(param) {
  return service.get(`/crc/users/findById?id=` + param, {
    headers: {
      'content-type': 'application/json'
    }
  })
}


// 通过二级请求一级
export function secondLevelRequest(param) {
  return service.get(`https://common.gcpdata.cn/api/dataSpecialty/getById/` + param, {
    headers: {
      'content-type': 'application/json'
    }
  })
}


// 角色切换的处理
export function switchRole(param) {
  return service.get(`/crc/users/switchRole?accountType=` + param, {
    headers: {
      'content-type': 'application/json'
    }
  })
}




// WEBPACK FOOTER //
// ./src/request/api.js